<div class="appointments-table-container">
  <div class="empty-state-container" *ngIf="!loading && appointments.length === 0">
    <div class="empty-state-content">
      <div class="empty-state-illustration">
        <img [src]="emptyStateConfig.image" [alt]="emptyStateConfig.title + ' illustration'" />
      </div>
      <div class="empty-state-text">
        <h3 class="empty-state-title">{{ emptyStateConfig.title }}</h3>
        <p class="empty-state-description" *ngIf="emptyStateConfig.description">
          {{ emptyStateConfig.description }}
        </p>
        <div class="empty-state-actions" *ngIf="emptyStateConfig.showAddButton">
          <button type="button" class="btn btn-primary" (click)="onAddNewAppointment()">
            <img src="assets/images/package/plus.svg" alt="" width="14" height="14" />
            Add New Appointments
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="table-scroll-wrapper" #tableScrollWrapper *ngIf="appointments.length > 0">
    <table mat-table [dataSource]="dataSource" class="mat-mdc-table appointments-mat-table">
      <!-- Appointment ID -->
      <ng-container matColumnDef="appointmentId">
        <th mat-header-cell *matHeaderCellDef style="min-width: 160px">
          <div class="column-header">
            <span>Appointment ID</span>
            <div class="sort-filter-icons">
              <span
                class="custom-sort-icon"
                [attr.data-sort-state]="getSortState('appointment_code')"
                (click)="onCustomSort('appointment_code')"
              >
                <img [src]="getSortIcon('appointment_code')" style="width: 20px" alt="Sort" />
              </span>
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let appointment"
          class="appointment-id"
          (click)="viewAppointment(appointment)"
        >
          {{ appointment.appointment_code }}
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef style="min-width: 120px">Status</th>
        <td mat-cell *matCellDef="let appointment" class="status-cell">
          <span
            class="status-badge"
            [ngClass]="getStatusBadgeClass(appointment.appointment_status)"
          >
            {{ getStatusLabel(appointment.appointment_status) }}
          </span>
        </td>
      </ng-container>

      <!-- Customer -->
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef style="min-width: 160px">
          <div class="column-header">
            <span>Customer Name</span>
            <div class="sort-filter-icons">
              <span
                class="custom-sort-icon"
                [attr.data-sort-state]="getSortState('customer_name')"
                (click)="onCustomSort('customer_name')"
              >
                <img [src]="getSortIcon('customer_name')" style="width: 20px" alt="Sort" />
              </span>
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let appointment" class="customer-name">
          {{ appointment.customer_name || '—' }}
        </td>
      </ng-container>

      <!-- Service -->
      <ng-container matColumnDef="service">
        <th mat-header-cell *matHeaderCellDef style="min-width: 180px">Service</th>
        <td mat-cell *matCellDef="let appointment" class="service">
          {{ appointment.package_name || '—' }}
        </td>
      </ng-container>

      <!-- Date/Time -->
      <ng-container matColumnDef="dateTime">
        <th mat-header-cell *matHeaderCellDef style="min-width: 180px">
          <div class="column-header">
            <span>Date &amp; Time</span>
            <div class="sort-filter-icons">
              <span
                class="custom-sort-icon"
                [attr.data-sort-state]="getSortState('appointment_time')"
                (click)="onCustomSort('appointment_time')"
              >
                <img [src]="getSortIcon('appointment_time')" style="width: 20px" alt="Sort" />
              </span>
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let appointment" class="date-time">
          {{ formatAppointmentDisplayTime(appointment) }}
        </td>
      </ng-container>

      <!-- Duration -->
      <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef style="min-width: 120px">Duration</th>
        <td
          mat-cell
          *matCellDef="let appointment"
          class="duration"
          [ngClass]="{
            'not-set': !(appointment.duration?.minutes || appointment.duration?.hours),
          }"
        >
          {{ formatDuration(appointment.duration) }}
        </td>
      </ng-container>

      <!-- Employee -->
      <ng-container matColumnDef="employee">
        <th mat-header-cell *matHeaderCellDef style="min-width: 150px">Employee</th>
        <td
          mat-cell
          *matCellDef="let appointment"
          class="employee"
          [ngClass]="{ unassigned: appointment.employee_name === 'Unassigned' }"
        >
          {{ appointment.employee_name || '—' }}
        </td>
      </ng-container>

      <!-- Location -->
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef style="min-width: 140px">Location</th>
        <td mat-cell *matCellDef="let appointment" class="location">
          {{ appointment.branch || '—' }}
        </td>
      </ng-container>

      <!-- Source -->
      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef style="min-width: 110px">
          <div class="column-header">
            <span>Source</span>
            <div class="sort-filter-icons">
              <span
                class="custom-sort-icon"
                [attr.data-sort-state]="getSortState('source')"
                (click)="onCustomSort('source')"
              >
                <img [src]="getSortIcon('source')" style="width: 20px" alt="Sort" />
              </span>
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let appointment" class="source">
          {{ appointment.source || '—' }}
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-header">Actions</th>
        <td mat-cell *matCellDef="let appointment" class="actions">
          <div class="action-buttons">
            <button
              *ngIf="appointment.appointment_status === 'confirmed'"
              type="button"
              class="mark-complete-btn"
              (click)="markComplete(appointment)"
            >
              <mat-icon>check</mat-icon>
              Mark Complete
            </button>

            <button
              *ngIf="appointment.appointment_status === 'pending'"
              type="button"
              class="add-info-btn"
              (click)="addInfoAndConfirm(appointment)"
            >
              Add Info &amp; Confirm
            </button>

            <button
              *ngIf="
                appointment.appointment_status === 'completed' ||
                appointment.appointment_status === 'cancelled'
              "
              type="button"
              class="mark-complete-btn disabled-btn"
              disabled
            >
              <mat-icon>check</mat-icon>
              Mark Complete
            </button>

            <button
              type="button"
              class="menu-btn"
              (click)="toggleDropdown($event, appointment)"
              aria-label="More actions"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <!-- Dropdown Backdrop -->
  <div class="dropdown-backdrop" *ngIf="showDropdown" (click)="closeDropdown()"></div>

  <!-- Custom Dropdown Menu -->
  <div
    class="custom-dropdown-menu"
    *ngIf="showDropdown"
    [style.top.px]="dropdownPosition.top"
    [style.left.px]="dropdownPosition.left"
  >
    <div class="dropdown-item" (click)="viewAppointment(selectedAppointment!)">
      <span>View</span>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.1665 1.75V4.08333C8.1665 4.23804 8.22796 4.38642 8.33736 4.49581C8.44675 4.60521 8.59513 4.66667 8.74984 4.66667H11.0832M8.1665 1.75H4.08317C3.77375 1.75 3.47701 1.87292 3.25821 2.09171C3.03942 2.3105 2.9165 2.60725 2.9165 2.91667V11.0833C2.9165 11.3928 3.03942 11.6895 3.25821 11.9083C3.47701 12.1271 3.77375 12.25 4.08317 12.25H9.9165C10.2259 12.25 10.5227 12.1271 10.7415 11.9083C10.9603 11.6895 11.0832 11.3928 11.0832 11.0833V4.66667M8.1665 1.75L11.0832 4.66667M5.24984 9.91667H8.74984M5.24984 7.58333H8.74984"
          stroke="#555963"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div
      class="dropdown-item"
      *ngIf="selectedAppointment?.appointment_status !== 'completed' && !isStaffUser"
      (click)="rescheduleAppointment(selectedAppointment!)"
    >
      <span>Reschedule</span>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6668 6.41666C11.5242 5.39012 11.048 4.43896 10.3115 3.7097C9.57512 2.98044 8.61935 2.51353 7.59147 2.3809C6.56359 2.24827 5.52061 2.45727 4.6232 2.97572C3.72578 3.49416 3.02372 4.29329 2.62516 5.24999M2.3335 2.91666V5.24999H4.66683M2.3335 7.58332C2.47616 8.60986 2.95237 9.56102 3.68879 10.2903C4.42521 11.0195 5.38097 11.4864 6.40886 11.6191C7.43674 11.7517 8.47972 11.5427 9.37713 11.0243C10.2745 10.5058 10.9766 9.70669 11.3752 8.74998M11.6668 11.0833V8.74998H9.3335"
          stroke="#555963"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div
      class="dropdown-item danger"
      *ngIf="selectedAppointment?.appointment_status !== 'cancelled' && !isStaffUser"
      (click)="cancelAppointment(selectedAppointment!)"
    >
      <span>Cancel</span>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.95833 4.95833L9.04167 9.04167M4.95833 9.04167L9.04167 4.95833M7 12.25C8.39239 12.25 9.72774 11.6969 10.7123 10.7123C11.6969 9.72774 12.25 8.39239 12.25 7C12.25 5.60761 11.6969 4.27226 10.7123 3.28769C9.72774 2.30312 8.39239 1.75 7 1.75C5.60761 1.75 4.27226 2.30312 3.28769 3.28769C2.30312 4.27226 1.75 5.60761 1.75 7C1.75 8.39239 2.30312 9.72774 3.28769 10.7123C4.27226 11.6969 5.60761 12.25 7 12.25Z"
          stroke="#DA1E28"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>

  <!-- Pagination -->
  <app-pagination-bar
    class="table-pagination"
    *ngIf="appointments.length > 0"
    [paginationData]="paginationData"
    [itemsPerPageOptions]="[5, 10, 20]"
    (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="onRowsPerPageChange($event)"
  >
  </app-pagination-bar>

  <!-- Service Filter Overlay Panel -->
  <p-popover
    #serviceFilterPanel
    [style]="{ width: '240px' }"
    styleClass="service-filter-panel"
    (onHide)="isServiceFilterOpen = false"
  >
    <ng-template pTemplate>
      <div class="service-filter-content">
        <div class="filter-options">
          <div
            *ngFor="let option of serviceOptions; trackBy: trackByOption"
            class="p-field-checkbox"
          >
            <mat-checkbox [value]="option.value" [(ngModel)]="selectedServices"></mat-checkbox>
            <label [for]="option.value" class="p5">{{ option.label }}</label>
          </div>
        </div>
        <div class="filter-actions">
          <button
            type="button"
            label="Clear"
            style="padding-left: 0px"
            class="btn btn-tertiary btn-small"
            [disabled]="!hasServiceFilterValues"
            (click)="clearServiceFilter()"
            [ngClass]="{ disabled: !hasServiceFilterValues }"
          >
            Clear
          </button>
          <div class="right-buttons">
            <button
              type="button"
              label="Cancel"
              class="btn btn-secondary btn-small"
              (click)="serviceFilterPanel.hide()"
            >
              Cancel
            </button>
            <button
              type="button"
              label="Apply"
              class="btn btn-primary btn-small"
              (click)="applyServiceFilter()"
              [disabled]="!selectedServices || selectedServices.length === 0"
              [ngClass]="{ disabled: !selectedServices || selectedServices.length === 0 }"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-popover>

  <!-- Status Filter Overlay Panel -->
  <p-popover
    #statusFilterPanel
    [style]="{ width: '240px' }"
    styleClass="status-filter-panel"
    (onHide)="isStatusFilterOpen = false"
  >
    <ng-template pTemplate>
      <div class="status-filter-content">
        <div class="filter-options">
          <div
            *ngFor="let option of statusOptions; trackBy: trackByOption"
            class="p-field-checkbox"
          >
            <mat-checkbox [value]="option.value" [(ngModel)]="selectedStatuses"></mat-checkbox>
            <label [for]="option.value" class="p5">{{ option.label }}</label>
          </div>
        </div>
        <div class="filter-actions">
          <button
            type="button"
            label="Clear"
            style="padding-left: 0px"
            class="btn btn-tertiary btn-small"
            [disabled]="!hasStatusFilterValues"
            (click)="clearStatusFilter()"
            [ngClass]="{ disabled: !hasStatusFilterValues }"
          >
            Clear
          </button>
          <div class="right-buttons">
            <button
              type="button"
              label="Cancel"
              class="btn btn-secondary btn-small"
              (click)="statusFilterPanel.hide()"
            >
              Cancel
            </button>
            <button
              type="button"
              label="Apply"
              class="btn btn-primary btn-small"
              (click)="applyStatusFilter()"
              [disabled]="!selectedStatuses || selectedStatuses.length === 0"
              [ngClass]="{ disabled: !selectedStatuses || selectedStatuses.length === 0 }"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-popover>

  <!-- Employee Filter Overlay Panel -->
  <p-popover
    #employeeFilterPanel
    [style]="{ width: '240px' }"
    styleClass="employee-filter-panel"
    (onHide)="isEmployeeFilterOpen = false"
  >
    <ng-template pTemplate>
      <div class="employee-filter-content">
        <div class="filter-options">
          <div
            *ngFor="let option of employeeOptions; trackBy: trackByOption"
            class="p-field-checkbox"
          >
            <mat-checkbox [value]="option.value" [(ngModel)]="selectedEmployees"></mat-checkbox>
            <label [for]="option.value" class="p5">{{ option.label }}</label>
          </div>
        </div>
        <div class="filter-actions">
          <button
            type="button"
            label="Clear"
            style="padding-left: 0px"
            class="btn btn-tertiary btn-small"
            [disabled]="!hasEmployeeFilterValues"
            (click)="clearEmployeeFilter()"
            [ngClass]="{ disabled: !hasEmployeeFilterValues }"
          >
            Clear
          </button>
          <div class="right-buttons">
            <button
              type="button"
              label="Cancel"
              class="btn btn-secondary btn-small"
              (click)="employeeFilterPanel.hide()"
            >
              Cancel
            </button>
            <button
              type="button"
              label="Apply"
              class="btn btn-primary btn-small"
              (click)="applyEmployeeFilter()"
              [disabled]="!selectedEmployees || selectedEmployees.length === 0"
              [ngClass]="{ disabled: !selectedEmployees || selectedEmployees.length === 0 }"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-popover>

  <!-- Location Filter Overlay Panel -->
  <p-popover
    #locationFilterPanel
    [style]="{ width: '240px' }"
    styleClass="location-filter-panel"
    (onHide)="isLocationFilterOpen = false"
  >
    <ng-template pTemplate>
      <div class="location-filter-content">
        <div class="filter-options">
          <div
            *ngFor="let option of locationOptions; trackBy: trackByOption"
            class="p-field-checkbox"
          >
            <mat-checkbox [value]="option.value" [(ngModel)]="selectedLocations"></mat-checkbox>
            <label [for]="option.value" class="p5">{{ option.label }}</label>
          </div>
        </div>
        <div class="filter-actions">
          <button
            type="button"
            label="Clear"
            style="padding-left: 0px"
            class="btn btn-tertiary btn-small"
            [disabled]="!hasLocationFilterValues"
            (click)="clearLocationFilter()"
            [ngClass]="{ disabled: !hasLocationFilterValues }"
          >
            Clear
          </button>
          <div class="right-buttons">
            <button
              type="button"
              label="Cancel"
              class="btn btn-secondary btn-small"
              (click)="locationFilterPanel.hide()"
            >
              Cancel
            </button>
            <button
              type="button"
              label="Apply"
              class="btn btn-primary btn-small"
              (click)="applyLocationFilter()"
              [disabled]="!selectedLocations || selectedLocations.length === 0"
              [ngClass]="{ disabled: !selectedLocations || selectedLocations.length === 0 }"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-popover>
</div>

<app-appointment-details-modal
  [isVisible]="isModalVisible"
  [appointment]="selectedAppointmentForModal"
  (close)="closeModal()"
  (appointmentUpdated)="onAppointmentUpdated()"
  (markCompleteAppointment)="onMarkCompleteFromDetailsModal($event)"
  (rescheduleAppointment)="onRescheduleFromDetailsModal($event)"
  (cancelAppointment)="onCancelFromDetailsModal($event)"
>
</app-appointment-details-modal>

<!-- Cancel Appointment Confirmation Modal -->
<app-cancel-appointment-modal
  [isVisible]="isCancelModalVisible"
  [appointment]="appointmentToCancel"
  (confirm)="onCancelConfirm($event)"
  (cancel)="onCancelModalClose()"
  (close)="onCancelModalClose()"
>
</app-cancel-appointment-modal>

<!-- Cancellation Reason Modal -->
<app-cancellation-reason-modal
  [isVisible]="isCancellationReasonModalVisible"
  [item]="appointmentToCancel"
  (submit)="onCancelReasonSubmit($event)"
  (close)="onCancellationReasonModalClose()"
>
</app-cancellation-reason-modal>

<!-- Cancellation Success Modal -->
<app-cancellation-success-modal
  [isVisible]="isCancellationSuccessModalVisible"
  (okay)="onCancellationSuccessModalOkay()"
  (createAnother)="onCancellationSuccessModalCreateAnother()"
  (close)="onCancellationSuccessModalClose()"
>
</app-cancellation-success-modal>

<!-- Cancellation Error Modal -->
<app-cancellation-error-modal
  [isVisible]="isCancellationErrorModalVisible"
  (okay)="onCancellationErrorModalOkay()"
  (close)="onCancellationErrorModalClose()"
>
</app-cancellation-error-modal>

<!-- Reschedule Appointment Modal -->
<app-reschedule-appointment-modal
  [isVisible]="isRescheduleModalVisible"
  [appointment]="appointmentToReschedule"
  [loading]="isRescheduleLoading"
  (closeModal)="onRescheduleModalClose()"
  (updateAppointment)="onRescheduleUpdate($event)"
>
</app-reschedule-appointment-modal>

<!-- Mark Complete Confirmation Modal -->
<app-mark-complete-modal
  [isVisible]="isMarkCompleteModalVisible"
  [appointment]="appointmentToMarkComplete"
  (confirm)="onMarkCompleteConfirm($event)"
  (cancel)="onMarkCompleteModalClose()"
  (close)="onMarkCompleteModalClose()"
>
</app-mark-complete-modal>
